/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import { Settings as SettingsStore } from '../../../../stores/settings'
import ReportTable from './reportTable'

type OrdersData = {
  Recipient: string
  'Send Date': Date
  Replied: boolean
  Maneuver: string
  Touch: number
  Subject: string
  'Opened Count': string
  Opened: boolean
  Name: string
  Title: string
  Company: string
}

type Props = {
  data: OrdersData[]
  title: string
  settings: SettingsStore
  setCurrentUser: React.Dispatch<any>
  setTypeProp: React.Dispatch<React.SetStateAction<string>>
  isChartOpened: boolean
  setselectedLeadsEmails: any
  setOpenActions: any
}

const Orders: FC<Props> = ({
  data,
  setCurrentUser,
  setTypeProp,
  isChartOpened,
  setselectedLeadsEmails,
  setOpenActions,
}) => {
  return (
    <>
      <ReportTable
        isChartOpened={isChartOpened}
        data={data}
        setCurrentUser={setCurrentUser}
        setTypeProp={setTypeProp}
        setselectedLeadsEmails={setselectedLeadsEmails}
        setOpenActions={setOpenActions}
      />
    </>
  )
}
export default Orders
